import React from "react";
import PropTypes from "prop-types";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import styles from "./styles.module.css";
import { connect } from "react-redux";
import moment from "moment";
import Loading from "../../../../../common/components/Loading";

const TopCard = ({
  capitalizeFirstLetter,
  formatNumber,
  setTabChangeValue,
  payment:{
    isSubscriptionDetailsLoading,
    subscriptionPlanName,
    subscriptionPlanAmount,
    subscriptionCurrentPeriodStartAt,
    subscriptionCurrentPeriodEndAt, 
    subscriptionActiveStatus,
  },
}) => {
  // Format member since date
  const getMemberSince = () => {
    if (subscriptionCurrentPeriodStartAt) {
      return moment(subscriptionCurrentPeriodStartAt).format("MMMM YYYY");
    }
    return "N/A"; // Default fallback
  };

  const isActive = subscriptionActiveStatus && String(subscriptionActiveStatus).toUpperCase() === "ACTIVE";

  const getDaysLeft = () => {
    if (!subscriptionCurrentPeriodEndAt) return 4;
    const gracePeriodEnd = moment(subscriptionCurrentPeriodEndAt).add(7, "days");
    const days = gracePeriodEnd.diff(moment(), "days");
    return days > 0 ? days : 0;
  };

  const getCountdown = () => {
    if (!subscriptionCurrentPeriodEndAt) return { days: 7, hours: "00" };
    const gracePeriodEnd = moment(subscriptionCurrentPeriodEndAt).add(7, "days");
    const now = moment();
    if (gracePeriodEnd.isSameOrBefore(now)) return { days: 0, hours: "00" };
    const totalHours = gracePeriodEnd.diff(now, "hours", true);
    const days = Math.floor(totalHours / 24);
    const hours = Math.floor(totalHours % 24);
    return { days, hours: String(hours).padStart(2, "0") };
  };

  return (
    <>
      {isSubscriptionDetailsLoading ? (
        <div className={styles.loadingContainer}>
          <Loading />
        </div>
      ) : (
      <div className={`${styles.topCard} ${!isActive ? styles.topCardInactive : ""}`}>
      <div className={styles.tagRow}>
        <div className={styles.membershipTag}>
          Member since {getMemberSince()}
        </div>
        <div className={isActive ? styles.statusTagActive : styles.statusTagInactive}>
          {isActive ? "ACTIVE" : "SUSPENDED"}
        </div>
      </div>
      
      <div className={styles.planNameContainer}>
        <div className={styles.planName}>
          {capitalizeFirstLetter(subscriptionPlanName)} plan
        </div>
        <div className={styles.planPrice}>
          LKR {formatNumber ? formatNumber(subscriptionPlanAmount) : subscriptionPlanAmount?.toFixed(2) || "1500.00"}
        </div>
      </div>
      
      <div className={styles.nextPayment}>
        Next payment:{" "}
        {subscriptionCurrentPeriodEndAt &&
          moment(subscriptionCurrentPeriodEndAt).format("D MMMM YYYY")}
      </div>
      {subscriptionCurrentPeriodEndAt &&
        moment().isSameOrAfter(moment(subscriptionCurrentPeriodEndAt), 'day') &&
        moment().isBefore(moment(subscriptionCurrentPeriodEndAt).add(7, "days"), 'day') && (() => {
          const { days, hours } = getCountdown();
          return (
            <div className={styles.daysLeftMessage}>
              You have {days} days {hours} hours left to pay your bill to avoid account suspension.
            </div>
          );
        })()}

      <div className={styles.divider}></div>

      <div 
        className={styles.manageLink}
        onClick={() => setTabChangeValue && setTabChangeValue(1)}
      >
        <span>Manage membership</span>
        <ArrowForwardIosIcon className={styles.chevron} />
      </div>
    </div>
    )}
    </>
  );
};

TopCard.propTypes = {
  subscriptionPlanName: PropTypes.string,
  capitalizeFirstLetter: PropTypes.func,
  formatNumber: PropTypes.func,
  subscriptionPlanAmount: PropTypes.number,
  subscriptionCurrentPeriodStartAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
  subscriptionCurrentPeriodEndAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
  subscriptionActiveStatus: PropTypes.string,
  setTabChangeValue: PropTypes.func,
  moment: PropTypes.func,
};

const mapStateToProps = (state) => ({ payment: state.paymentState });

export default connect(mapStateToProps)(
  TopCard
);